import { RouterStore } from 'mobx-router';

const CustomRouter = {
  router: new RouterStore()
};

export default CustomRouter;
